module.exports = __webpack_public_path__ + "img/line_v.8c7d3efa.svg";